import * as CodeMirror from 'codemirror'
(typeof global === 'undefined' ? self : global).CodeMirror = CodeMirror
